/**
 * 현재 화면에 마운트된 Canvas 오버레이 렌더러 레지스트리.
 *
 * CANVAS_EDITOR 플래그가 켜지면 에디터 화면은 JointJS paper 가 아니라 이 렌더러가
 * 그린다(paper.el 은 visibility:hidden, SVG cell view 도 만들어지지 않는다).
 * 그래서 셀 위에 무언가를 얹던 코드 — 자동 관계 생성의 반경 밖 타겟 표시, 생성
 * 직후 결과 강조 — 는 paper.findViewByModel 대신 여기서 렌더러를 얻어야 한다.
 * 플래그가 꺼져 있거나 아직 마운트 전이면 null 이고, 호출부는 기존 SVG 경로를 쓴다.
 */
import type { CanvasRenderer } from './CanvasRenderer'

let activeRenderer: CanvasRenderer | null = null

export const setActiveCanvasRenderer = (renderer: CanvasRenderer | null): void => {
  activeRenderer = renderer
}

export const getActiveCanvasRenderer = (): CanvasRenderer | null => activeRenderer
